module.exports = __webpack_public_path__ + "img/cube.c2b79cba.svg";